





































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';
import { Testimonial, User } from 'frontend/types';

import AppRating from 'frontend/views/landing/AppRating.vue';
import TrustpilotRating from 'frontend/views/landing/TrustpilotRating.vue';

@Component({
  components: {
    AppRating,
    TrustpilotRating,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
    ...mapState('premiumTestimonials', {
      premiumTestimonials: ({ items }: { items: Testimonial[] }) => items,
    }),
    ...mapState('globals', ['user']),
  },
})
export default class Reviews extends Vue {
  @Prop(Boolean) private readonly forFullPaywall!: boolean | undefined;
  @Prop(Boolean) private readonly onTrialPaywall!: boolean | undefined;
  @Prop({ type: Boolean, default: false }) private readonly isExperiment!: boolean;

  private user!: User;
}
